import React from "react";
import { useSelector } from "react-redux";
import { getCurrencySymbol } from "../../../features/utils/currency";
import PassengerInfo from "../../../pages/Orders/Flight/Booked/PassengerInfo";
import { getPassengerCategory } from "../../../utils/getPassengerCategory";
import moment from "moment";
import TicketFlightInfo from "../../../pages/Orders/Flight/Booked/TicketFlightInfo";
import { formatMoney } from "../../../features/utils/formatMoney";
import ReactDOMServer from 'react-dom/server';

const FlightDocTemplate = ({data,switches=[true,true,true,true,true],selectedPassengers}) => {
  // Function to generate HTML content
    const {user} = useSelector(state => state.user.userData);
    const orderData = data?.booking?.flightBooking?.at(0)

    console.log(data);
    console.log(selectedPassengers);

    const currency = getCurrencySymbol(
    data?.booking?.flightBooking?.at(0)?.currency,
    )

    
    // const segments = 
    //   (data?.orderDetail?.pricing?.offers &&
    //   Array.isArray(data?.orderDetail?.pricing?.offers) &&
    //   data?.orderDetail?.pricing?.offers?.flatMap((offer) =>
    //     offer.directions.flat(),
    //   )) || data?.booking?.flightBooking?.at(0)?.flights;

    
    if(!data)
        return null;

    const airlinePNR = Array.from(new Set(orderData?.travelers?.at(0)?.pnrList?.map((pnr) => pnr?.airlinePnr)))

    const Component = () => (
      <div className='flex flex-col gap-10 p-6 card pdf-w' id='flightDoc'>
        <div className='flex flex-col gap-10 p-5'>
          <div className='flex justify-between gap-4'>
            <div className="flex flex-col gap-2">
              {/* <div className="h-7" style={{backgroundImage: `url(${user?.detail?.agencyLogo})`, backgroundSize: 'contain', backgroundRepeat: 'no-repeat', backgroundPosition: 'left'}}>
              </div> */}
              {/* <div className="h-7">
                <img src={user?.detail?.agencyLogo} alt='' className="w-full h-full object-contain object-left" />
              </div> */}
              <b className="text-[30px]">{user?.detail?.tradingName}</b>
              <div className="flex flex-col">
                <span>{user?.detail?.address?.businessLocation}</span>
                <span>{user?.detail?.businessPhone || user?.detail?.businessEmail}</span>
              </div>
            </div>
            {/* <Logo /> */}
            <div className="flex flex-col gap-3 text-end">
              <div className="flex justify-end">
                <img src={user?.detail?.agencyLogo} className="logo" alt='' />
              </div>

              <div className='flex flex-col '>
                Booking Reference
                {airlinePNR ? 
                  <b className="text-xl">{airlinePNR?.join(', ')}</b>
                  :
                  <div className='text-theme1'>{data?.booking?.bookingId}</div>
                }
                </div>
            </div>
          </div>
          <hr />
          {orderData?.status === 'Issued' ?
            <div className="text-center flex flex-col gap-2">
                {/* <h2>{user?.detail?.tradingName}</h2> */}
                <b className="uppercase text-[30px]">Itinerary</b>
            </div>
          :null}


          {['Paid','Booked','Pending','Not Paid']?.includes(orderData?.status) ?
            <div className='bg-primary/10 p-4 rounded-md'>
              Booking status: {orderData?.status} | Your booking expires on : {moment(orderData?.ticketingExpiry)?.format('DD MMM YYYY HH:mm')}
            </div>
          :null}

          {switches?.at(0) ? 
            <div className='flex gap-2 flex-col'>
              <h5>Passenger Information</h5>
              <div className="">
                {
                  (selectedPassengers?.length ? selectedPassengers : orderData?.travelers)?.map((traveler,i) => (
                    <PassengerInfo key={i} index={i} hideCount
                      label={getPassengerCategory(traveler.birthDate)}
                      traveler={traveler}
                      order={data}
                    />
                  ))
                }

                  {/* {data?.orderDetail?.travelers &&
                    Array.isArray(data?.orderDetail?.travelers) &&
                    data?.orderDetail?.travelers?.map((traveler) => (
                      <PassengerInfo
                        label={getPassengerCategory(traveler.dateOfBirth)}
                        traveler={traveler}
                        order={data}
                      />
                    ))} */}
                  {/* <PassengerInfo label={"Adult"} />
                  <PassengerInfo label={"Child"} /> */}
                </div>
                {/* <PriceSummary onPDF={true} data={data} /> */}

              {/* <div className='border border-primary/50 p-4'>
                <PassengerInfo />
              </div> */}
            </div>
          :null}

          {switches?.at(1) ? 
            <div className='flex flex-col gap-5'>
              <div className='flex justify-between gap-4 items-center'>
                <h6>Flight Details</h6>
                {/* <div>
                  <img src={segments?.at(0)?.airline?.image?.url || segments?.at(0)?.airlineImage} alt="" className="w-16 h-16" />
                </div> */}
              </div>

              <div className=''>
                <TicketFlightInfo data={data} hideBaggage={!switches?.at(2)} />
              </div>
            </div>
          :null}

          {orderData?.status === 'Issued' ? 
            <div className="flex flex-col gap-2 w-[900px]">
              <span>
                Please prepare/print your itinerary for customs security check. Remember to bring your passport or other identification document with you,
                make sure the information is matched with your itinerary to avoid discrepancy.
              </span>

              <span>
              For international flights, you are suggested to arrive at the airport at least 3-4 hours prior to your departure time to check in and go through
              security. 
              </span>
              <span>
                For connecting flights, please confirm at the counter whether not you can check your luggage through to the final destination when
                you check in.
              </span>
              <span>
                Please contact us in case of change request at least 1 to 2 business days before the departure time to avoid the potential no-show penalty.
                In case the flight is cancelled or delayed when you are at the airport or within 1 to 2 business days before the departure time, you are highly
                recommended to submit your change request at the airline counter in the airport for free. If the staff at the airline counter could not assist you on processing the request, please request them to issue a certificate of flight delay/cancellation so you are able to apply involuntary
                change/refund later.
              </span>
            </div>
          :
            switches?.at(3) ? 
              <div className="flex gap-4 justify-between">
                <h5>Trip Total ({currency}):</h5>
                <h5>{formatMoney(data?.booking?.flightBooking?.at(0)?.customerPayable, currency)}</h5>
              </div>
            :null
          }

          
        </div>
  
  
        {/* <div className='flex gap-4 flex-col'>
          <h5>Ticket numbers</h5>
          <div className='border border-primary/50 p-4 flex flex-col gap-4'>
            <span>Daniel Atelly: 1</span>
          </div>
        </div> */}
        
      </div>
    )  

  // Function to generate CSS styles
  const generateCSS = () => {
    return `
      .flight-doc-template {
        margin: 0;
        padding: 0;
        font-family: Arial, sans-serif;
        box-sizing: border-box;
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
      }

        .flight-doc-template .logo {
            width: 70px;
            height: 70px;
        }

        .pdf-w {
          width: 1000px
        }
    `;
  };

  const HtmlStatic = ReactDOMServer.renderToStaticMarkup(<Component />)
  // Render the generated HTML and CSS
  return (
    <div className="flight-doc-template">
      <div dangerouslySetInnerHTML={{ __html: HtmlStatic }} />
      <style>{generateCSS()}</style>
    </div>
  );
};

export default FlightDocTemplate;
